import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Edit } from '@material-ui/icons';
import messages from 'modules/booking/messages';
import { ActionItem } from 'common/components';
import { restrictModifyEventByTime } from 'utils/booking.utils';
import ActionItemWarningIconByTime from 'common/components/ActionsMenu/ActionItemWarningIconByTime';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';

interface IBookingActionItemEdit {
  onClick: () => void;
  secondsBeforeEvent: number;
  editRestrictionBeforeDays?: number | null;
}

const BookingActionItemEdit: FC<IBookingActionItemEdit> = ({
  onClick,
  secondsBeforeEvent,
  editRestrictionBeforeDays,
}) => {
  const intl = useIntl();
  let disableReason: JSX.Element | null = null;

  if (restrictModifyEventByTime(secondsBeforeEvent, editRestrictionBeforeDays)) {
    disableReason = (
      <ActionItemWarningIconByTime tooltipMsgType="restrictEdit" days={editRestrictionBeforeDays} />
    );
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="editEventAction"
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      icon={<Edit />}
    >
      <BookingActionItemContainer message={intl.formatMessage(messages.editEvent)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemEdit;
